import React, { useEffect, useState } from 'react';
import { Button, Spin, Card, Row, Col, Typography, Layout } from 'antd';
import UserStore from 'stores/UserStore';
import Logo from 'components/common/Logo';
import { LoadingOutlined } from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;
const { Content } = Layout;

const PortalLoading = props => {
    const [seconds, setSeconds] = useState(0);

    let interval;

    useEffect(() => {
        interval = setInterval(() => {
            setSeconds(seconds => seconds + 1);
        }, 1000);

        return function cleanup() {
            clearInterval(interval);
        };
    }, []);

    return (
        <div className="portal-loading">
            {seconds > 30 ? (
                <div className="d-flex flex-column align-items-start p-3">
                    <Logo style={{ height: '50px', margin: '0 0 25px 0', padding: '0' }} />
                    <Title level={1} className="mb-1">{`Sorry, our website is currently unavailable :(`}</Title>
                    <Text className="font-size-lg text-muted mb-3">{`Please try again in a few minutes.`}</Text>
                    <Paragraph className="font-size-md">
                        To speak with a customer service representative, please call us at{' '}
                        <a className="font-weight-bold" href="tel:331-223-4378">
                            (331) 223-4378
                        </a>{' '}
                        or email{' '}
                        <a className="font-weight-bold" href="mailto:sales@parts-badger.com">
                            sales@parts-badger.com
                        </a>
                    </Paragraph>

                    {UserStore?.isAuthenticated ? (
                        <Button type="primary" onClick={() => UserStore.logout().catch(() => undefined)}>
                            Logout
                        </Button>
                    ) : null}
                </div>
            ) : (
                <Spin indicator={<LoadingOutlined />} size="large" />
            )}
        </div>
    );
};

export default PortalLoading;
